import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import Spinner from '@/components/ui/Spinner';
import { LandingPage } from '@/pages/marketing';

/**
 * Root path handler that shows landing page or redirects to dashboard.
 * WP-LANDING-1: Conditional routing based on authentication state.
 *
 * Behavior:
 * - While auth state is loading: shows loading spinner
 * - If authenticated: redirects to /dashboard
 * - If not authenticated: renders LandingPage inline
 */
export default function RootRedirect() {
  const { isAuthenticated, isLoading } = useAuthStore();

  // Show loading spinner while checking auth status
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <Spinner size="lg" />
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect authenticated users to dashboard
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  // Show landing page for unauthenticated visitors
  return <LandingPage />;
}
